import { mapState } from 'vuex';

import { formRenderContainerMixin } from '@/mixins/formRenderContainer';

export const generateMixin = {
  mixins: [formRenderContainerMixin],
  data() {
    return { selectedView: null };
  },
  computed: {
    ...mapState({
      views: state => {
        const views = state.view.list.map(view => ({ ...view, name: view.data?.listName || view.name }));
        views.sort((viewA, viewB) => viewA.name.localeCompare(viewB.name, undefined, { numeric: true }));
        return views;
      }
    }),
    // Aktualnie wybrany widok
    view() {},
    // Schema
    schema() {
      return this.view?.schema?.schema && JSON.parse(this.view.schema.schema);
    },
    // Ukryte formularze zablokowane
    postFormsDisabled() {
      return !!this.view?.schema && (!this.loadedSchema || !!this.$schema.$validateAll().length);
    },
    // Pola ukrytego formularza
    viewFormFields() {
      const data = this.$schema.$getData();
      return data ? Object.keys(data).map(key => ({ name: key, value: data[key] })) : [];
    }
  },
  methods: {
    // @vuese
    // Ładuje schemę
    loadSchema() {},
    // @vuese
    // Zamykanie modala
    close() {
      this.$emit('close');
    }
  },
  watch: {
    // Przeładowuje schemę po zmianie wybranego widoku
    view() {
      this.loadedSchema = false;
      this.loadSchema();
    }
  }
};
